const getDcType = state => id => state.dcTypes.find(type => type.id === id)
export default {
  getOrgType: state => id => state.orgTypes.find(type => type.id === id),
  getDcType,
  isDc: state => id => id === state.DSc
      || id === state.independentResearcherDSc
      || id === state.targetedDSc
      || id === state.doctoralDScOutsideQuota
      || id === state.doctoralDScUnderContract,
  getLetterType: state => id => state.letterTypes.find(type => type.id === id),
  getLetterStatus: state => id => state.letterStatuses.find(status => status.id === id),
  getLetterStatusColor: state => id => {
    let color
    switch (id) {
      case state.letterStatusAccepted:
        color = 'success'
        break
      case state.letterStatusRejected:
        color = 'danger'
        break
      case state.letterStatusPending:
        color = 'warning'
        break
      case state.letterStatusDraft:
        color = 'secondary'
        break
      default:
        color = null
    }
    return color
  },
  getTargetedDcTypes: state => state.dcTypes.filter(dcType => [600, 700].includes(dcType.id)),
  getSimpleDcTypes: state => state.dcTypes.filter(dcType => ![400, 500, 800, 900, 1000, 1100, 1200, 1300].includes(dcType.id)),
  getApplyDocumentStatus: state => id => state.applyDocumentStatuses.find(status => status.id === id),
  getStudentStatuses: state => () => state.applyDocumentStatuses.filter(status => [state.applyDocumentAdmittedToStudy,
    state.applyDocumentHasBeenCanceled,
    state.applyDocumentHasGraduated,
    state.applyDocumentFailedInExam,
    state.applyDocumentSuccessfullyDefended,
    state.applyDocumentOnAcademicLeave].includes(status.id)),
  getApplyDocumentStatusColor: state => id => {
    let color
    switch (id) {
      case state.applyDocumentStatusAccepted:
      case state.applyDocumentAdmittedToStudy:
      case state.applyDocumentHasGraduated:
        color = 'success'
        break
      case state.applyDocumentStatusRejected:
      case state.applyDocumentFailedInExam:
      case state.applyDocumentHasBeenCanceled:
        color = 'danger'
        break
      case state.applyDocumentStatusPending:
        color = 'warning'
        break
      case state.applyDocumentStatusDraft:
        color = 'secondary'
        break
      default:
        color = null
    }
    return color
  },
  getEduLangType: state => id => state.eduLangTypes.find(type => type.id === id),
  getScientificWorkType: state => id => state.scientificWorkTypes.find(type => type.id === id),
  getUserRole: state => id => state.roles.find(role => role.id === id),
  getUserType: state => type => state.userTypes.find(userType => userType.type === type),
  getUserGd: state => type => state.genders.find(gender => gender.id === type),
  getQuoteOrgType: state => type => state.quoteOrgTypes.find(quoteOrgType => quoteOrgType.id === type),
  getTotalQuoteType: state => type => state.totalQuoteTypes.find(totalQuoteType => totalQuoteType.id === type),
  getDcTypeForQuarter: state => quarter => {
    let dcTypes = [
      getDcType(state)(state.independentResearcherDSc),
      getDcType(state)(state.independentResearcherPhD),
    ]
    if (quarter === 1) {
      dcTypes = state.dcTypes
    }
    return dcTypes
  },
  getQuoteDistributionStatus: state => id => state.quoteDistributions.find(status => status.id === id),
  getQuoteDistributionStatusColor: state => id => {
    let color
    switch (id) {
      case state.quoteDistributionAccepted:
        color = 'success'
        break
      case state.quoteDistributionRejected:
        color = 'danger'
        break
      case state.quoteDistributionPending:
        color = 'warning'
        break
      case state.quoteDistributionDraft:
        color = 'secondary'
        break
      default:
        color = null
    }
    return color
  },
  getExamFileType: state => type => state.examFileTypes.find(fileType => fileType.id === type),
  getExamResultStatus: state => status => state.examResultStatuses.find(resultStatus => resultStatus.id === status),
  getExamResultColor: state => status => {
    let color
    switch (status) {
      case state.examResultAdditionalAccepted:
      case state.examResultAccepted:
        color = 'success'
        break
      case state.examResultNotAccepted:
        color = 'danger'
        break
      default:
        color = null
    }
    return color
  },
  getExamStatus: state => status => state.examStatuses.find(examStatus => examStatus.id === status),
  getPostStatus: state => status => state.postStatuses.find(postStatus => postStatus.id === status),
  getAdditionalExamSubject: state => id => state.additionalExamSubjects.find(subject => subject.id === id),
  getAdditionalExamCheckStatus: state => id => state.additionalExamCheckStatus.find(check => check.id === id),
  getCheckMonitoringStatusCheckStatus: state => id => state.checkMonitoringStatus.find(check => check.id === id),
  getQuoteAgreementStatus: state => id => state.quoteAgreementStatus.find(check => check.id === id),
  getCheckMonitoringReasonStatusCheckStatus: state => id => {
    const check = state.checkMonitoringReasonStatus.find(check => check.id === id)
    return check || ''
  },
  getPeriod: state => id => state.periodList.find(period => period.id === id),
  getOrganizationStatus: state => status => state.organizationStatuses.find(orgStatus => orgStatus.id === status),
  getOrganizationStatusColor: state => status => (status === state.organizationStatusActive ? 'success' : 'danger'),
}
